import Swiper from "swiper";
import {
  Navigation,
  A11y,
  Keyboard,
  EffectFade,
  Pagination,
} from "swiper/modules";

var header;

function scrollHandler() {
  var sc = window.scrollY || window.pageYOffset;

  if (sc > 97) {
    header.classList.add("header--fixed");
  } else {
    if (header.classList.contains("header--fixed")) {
      header.classList.remove("header--fixed");
    }
  }
}

function initSlider(container, opts, fade) {
  const arrows = [container.prev().prev().val(), container.prev().val()];
  const htmlArrow = '<a class="slider-arrow slider-arrow--';
  const fading = typeof fade === "boolean" ? fade : true;

  const slickOpts = {
    arrows: true,
    prevArrow:
      htmlArrow +
      'prev" href="#"><img src="' +
      arrows[0] +
      '" alt="arr-left"></a>',
    nextArrow:
      htmlArrow +
      'next" href="#"><img src="' +
      arrows[1] +
      '" alt="arr-right"></a>',
    infinite: true,
    autoplaySpeed: 3000,
    fade: fading,
    accessibility: true,
    // cssEase: 'linear',
  };

  const optsCustom = opts || {};

  container.slick(Object.assign(slickOpts, optsCustom));
}

function reinitSlider(elem) {
  var sliderContainer = $(elem).closest(".container");

  if (window.innerWidth > 575) {
    var sliderContainerOffset =
      (window.innerWidth - sliderContainer.width()) / 2;
    $(sliderContainer).css({
      "padding-left": "0px",
      "margin-right": "0px",
      "max-width": "calc(100% - " + sliderContainerOffset + "px)",
    });
  } else {
    sliderContainer.removeAttr("style");
  }
}

function fitArticleLinksHeight(items) {
  if (window.innerWidth > 1199.5) {
    items.each(function () {
      var textElem = $(this).find(".tags-article__text");
      var linksElem = $(this).find(".tags-article__links");
      var textElemHeight = textElem.height();
      linksElem.css("min-height", textElemHeight + "px");
    });
  }
}

function fitVideo(items) {
  items.each(function () {
    var dataTarget = this.dataset.target;
    var image = $(this)
      .parent()
      .find('[data-js="' + dataTarget + '"] img');

    if (!image) {
      return;
    }

    var imageOffsetTop = image.offset().top;
    $(this).css({
      top: imageOffsetTop + "px",
      width: image.width() + "px",
      height: image.height() + "px",
    });
  });
}

(function ($) {
  // DOM ready
  $(function () {
    header = document.querySelector("header");

    // Scroll handler
    $(window).on("scroll", scrollHandler);

    var sc = window.scrollY || window.pageYOffset;
    if (sc > 97) {
      header.classList.add("header--fixed");
    }

    // Fit float text blocks
    var tagsArticlsBlock = $(".tags-article");
    var videoBlock = $("section .video[data-target]");
    if (tagsArticlsBlock.length) {
      fitArticleLinksHeight(tagsArticlsBlock);
    }
    if (videoBlock.length) {
      fitVideo(videoBlock);

      $(window).on("resize", function () {
        fitVideo(videoBlock);
      });
    }

    // Sliders initialization
    var sliders = [
      $("section .slider--1"),
      $("section .slider--2"),
      $("section .slider--3"),
      $("section .slider--4"),
      $("section .slider--5"),
    ];

    if (sliders[0].length > 0) {
      sliders[0].each(function () {
        let slider = this;
        initSlider($(slider), {
          slidesToShow: 1,
          dots: false,
          speed: 1200,
          autoplay: false,
        });
      });
    }

    if (sliders[1].length > 0) {
      sliders[1].each(function () {
        let slider = this;
        initSlider(
          $(slider),
          {
            slidesToShow: 3,
            dots: false,
            speed: 800,
            autoplay: true,
            centerMode: true,
            centerPadding: "30px",
            variableWidth: true,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                },
              },
              {
                breakpoint: 575,
                settings: {
                  centerPadding: "20px",
                },
              },
            ],
          },
          false
        );
      });
    }

    if (sliders[2].length > 0) {
      sliders[2].each(function () {
        let slider = this;
        reinitSlider(slider);
        setTimeout(function () {
          initSlider(
            $(slider),
            {
              slidesToShow: 3,
              dots: false,
              // rtl: true,
              speed: 500,
              autoplay: false,
              variableWidth: true,
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    dots: true,
                  },
                },
                {
                  breakpoint: 575,
                  settings: {
                    dots: true,
                    slidesToShow: 2,
                  },
                },
                {
                  breakpoint: 400,
                  settings: {
                    dots: true,
                    slidesToShow: 1,
                  },
                },
              ],
            },
            false
          );
        }, 500);
      });
    }

    if (sliders[3].length > 0) {
      sliders[3].each(function () {
        let slider = this;
        initSlider($(slider), {
          slidesToShow: 1,
          dots: false,
          speed: 1200,
          autoplay: false,
        });
      });
    }

    if (sliders[4].length > 0) {
      sliders[4].each(function () {
        let slider = this;
        initSlider($(slider), {
          slidesToShow: 1,
          dots: false,
          speed: 1200,
          autoplay: false,
        });
      });
    }

    // Resize event

    $(window).on("resize", function (e) {
      if (!e.isTrigger) {
        clearTimeout(this._timer);
        this._timer = setTimeout(function () {
          if (sliders[2].length > 0) {
            sliders[2].each(function () {
              let slider = this;
              reinitSlider(slider);
            });
          }
          if (tagsArticlsBlock.length) {
            fitArticleLinksHeight(tagsArticlsBlock);
          }
        }, 250);
      }
    });

    // Click handlers
    $("header .btn--burger").click(function () {
      $(this).toggleClass("active");
      $(this).next().toggleClass("show");
    });

    $('header .search [data-js="header-search"]').click(function (e) {
      var $form = $(this).closest("form");
      if (!$form.hasClass("search--active")) {
        e.preventDefault();
        $form.toggleClass("search--active");
        $form.prev().toggleClass("fade-out");
      }
    });

    $('footer [data-js="to-top"]').click(function (e) {
      e.preventDefault();
      $("html,body").animate({ scrollTop: 0 }, 750);
    });

    // Videos
    if ($("section .btn--video").length) {
      var btnVideo = $("section .btn--video");
      var alignBtn = function () {
        var offset = $(btnVideo).prev().height() / 2 - btnVideo.height() / 1.5;
        $(btnVideo).css("top", offset + "px");
      };

      setTimeout(function () {
        alignBtn();
      }, 900);

      $(window).on("resize", function (e) {
        if (!e.isTrigger) {
          clearTimeout(this._timer);
          this._timer = setTimeout(alignBtn, 250);
        }
      });

      btnVideo.on("click", function (e) {
        e.preventDefault();

        var video = this.previousElementSibling;
        var container = $(this).closest(".video");
        var image = container.find(".btn img");

        if (video.currentTime > 0 && !video.paused && !video.ended) {
          video.pause();
          video.removeAttribute("style");
          container.removeClass("video--active");
          image.attr("src", image.attr("data-src_play"));
        } else {
          video.muted = false;
          video.currentTime = 0;
          video.play();
          container.addClass("video--active");
          image.attr("src", image.attr("data-src_pause"));
        }
      });
    }

    // Lightbox
    $(".content-line").each(function () {
      $(this)
        .find(".lightbox")
        .magnificPopup({
          type: "image",
          closeOnContentClick: true,
          mainClass: "mfp-img-mobile",
          tLoading: "Lädt...",
          tClose: "Schließen (Esc)", // Alt text on close button
          gallery: {
            enabled: true,
            tPrev: "Voriges (linke Pfeiltaste)", // Alt text on left arrow
            tNext: "Nächstes (rechte Pfeiltaste)", // Alt text on right arrow
            tCounter: "%curr% von %total%",
          },
          image: {
            tError: '<a href="%url%">Das Bild</a> konnte nicht geladen werden.',
            titleSrc: function (item) {
              return item.el.find("img").attr("title");
            },
          },
          ajax: {
            tError:
              '<a href="%url%">Der Inhalt</a> konnte nicht geladen werden.',
          },
        });
    });

    function transferHeaderHeight() {
      let height = $("header.header").height();
      if (window.innerWidth <= 991) {
        $(".header-spacer").css("margin-top", height);
      } else {
        $(".header-spacer").css("margin-top", 0);
        $(".header-spacer:not('.home')").css("margin-top", height);
      }
      $.fn.matchHeight._update();
    }

    $(window).on("resize", function () {
      transferHeaderHeight();
    });

    $('[loading="lazy"]').on("load", function () {
      $.fn.matchHeight._update();
    });

    $(document).ready(function () {
      // =========================================================
      // TEAM-SLIDER update of matchHeight
      // =========================================================
      $(".ctype-ce_team_slider .slider").on(
        "init",
        function (event, slick, direction) {
          $('[data-mh="team-slider-title"]').matchHeight({ byRow: false });
          $('[data-mh="team-slider-content"]').matchHeight({ byRow: false });
          $.fn.matchHeight._update();
        }
      );
      $(".ctype-ce_team_slider .slider").on(
        "afterChange",
        function (event, slick, direction) {
          $('[data-mh="team-slider-title"]').matchHeight({ byRow: false });
          $('[data-mh="team-slider-content"]').matchHeight({ byRow: false });
        }
      );
      // =========================================================
      transferHeaderHeight();
    });

    $("[data-link]").on("click", function (e) {
      if ($(e.target).is("a, a *")) {
        // console.log("");
      } else {
        if ($(e.target).parents(".linked").data("link")) {
          window.location = $(e.target).parents(".linked").data("link");
        }
      }
    });

    transferHeaderHeight();

    // New team slider
    let teamSwiperContainers = document.querySelectorAll(".swiper-container--team");
    teamSwiperContainers.forEach(function (swiperContainer, index) {
        let cID = swiperContainer.id;
        let id = swiperContainer.querySelector(".swiper").id;
        let tlSlider;
        if (swiperContainer.classList.contains("swiper-container--team")) {
            console.log("New team slider found", swiperContainer);
            console.log("Swiper ID:", cID, id);
            tlSlider = new Swiper('#' + id, {
                modules: [Navigation, Keyboard, A11y, Pagination],
                keyboard: { enabled: true },
                a11y: { enabled: true },
                speed: 500,
                loop: true,
                navigation: {
                    nextEl: `#${cID} .swiper-button-next`,
                    prevEl: `#${cID} .swiper-button-prev`,
                },
                slidesPerView: 1.5,
                spaceBetween: 20,
                centeredSlides: true,
                loop: true,
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        centeredSlides: false,
                        loop: false,
                        pagination: {
                            el: ".swiper-pagination",
                            type: "progressbar",
                        },
                    },
                    992: {
                        slidesPerView: 2.5,
                        spaceBetween: 20,
                        centeredSlides: false,
                        loop: false,
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                        centeredSlides: false,
                        loop: false,
                    },
                    1400: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                        centeredSlides: false,
                        loop: false,
                    },
                },
                on: {
                    afterInit: function () {
                      console.log("New team slider initialized");
                      swiperContainer.classList.add("slider-init");
                    },
                },
            });
        }
    })
    // New team slider end


  });
})(jQuery);
